import { User } from '../types';
import { storageKeys } from '../config';

const canUseStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

export const loadJson = <T,>(key: string, fallback: T): T => {
  if (!canUseStorage()) {
    return fallback;
  }

  const raw = window.localStorage.getItem(key);
  if (!raw) {
    return fallback;
  }

  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};

export const saveJson = <T,>(key: string, value: T) => {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(key, JSON.stringify(value));
};

export const readStoredUser = (): User | null => {
  const user = loadJson<User | null>(storageKeys.user, null);
  if (!user) {
    return null;
  }

  return {
    ...user,
    id: Number(user.id),
  };
};